import { portugueseAlphabeto } from 'util/validator';
import * as Yup from 'yup';

import { yupResolver } from '@hookform/resolvers/yup';

const requiredString = (name: string) => {
  const message = `${name} não pode ficar em branco`;
  return Yup.string().typeError(message).required(message);
};

export const managerValidation = () =>
  yupResolver(
    Yup.object().shape({
      name: requiredString('Nome do colaborador')
        .max(100, 'Limite de caracter atingindo!')
        .test(
          'nameValidation',
          'Não é permitido números e nem caracteres especiais',
          (value) => {
            return portugueseAlphabeto(value);
          }
        ),
      email: requiredString('E-mail').email('E-mail inválido'),
    })
  );
